import { styled } from 'styled-components';

export const FoodTitle = ({ title }: { title: string }) => (
  <Title length={title.length}> {title} </Title>
);

const Title = styled.div<{ length: number }>`
  font-size: ${({ length }) => (length > 60 ? '16px' : '20px')};
  color: #ffffff;
  height: 80px;
  text-overflow: ellipsis;
  overflow: hidden;
`;
